export default "__VITE_ASSET__BMDeL99v__"